import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=01502587&scoped=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=01502587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01502587",
  null
  
)

export default component.exports